import Image from '@/components/atomic/atoms/layout/image';
import ImageWithPromoPanel from '@/components/atomic/atoms/layout/image-with-promo-panel';
import LisOfLinks from '@/components/atomic/molecules/data-display/list-of-links';
import LinkGroup from '@/components/atomic/molecules/utils/portals/desktop-menu-container/templates/shop-now-template/column-component-link-group';
import MenuContainer from '@/components/atomic/molecules/utils/portals/desktop-menu-container/templates/shop-now-template/menu-container';
import ChatAppContactDetails from '@/components/atomic/templates/navigation/chatapp-contactdetails';
import ColumnLayout from '@/components/atomic/templates/navigation/column-layout';
import ColumnLayoutList from '@/components/atomic/templates/navigation/column-layout-list';
import ColumnLayoutListCarousel from '@/components/atomic/templates/navigation/column-layout-list-carousel';
import ContentHeader from '@/components/atomic/templates/navigation/contentheader';
import GenericColumnLayoutCarousel from '@/components/atomic/templates/navigation/generic-column-layout-carousel';
import LanguageSelector from '@/components/atomic/templates/navigation/languageselector';
import LiveChat from '@/components/atomic/templates/navigation/livechat';
import MyAccount from '@/components/atomic/templates/navigation/myaccount';
import NameplateCard from '@/components/atomic/templates/navigation/nameplatecard';
import NavForms from '@/components/atomic/templates/navigation/navforms';
import NavigationBrand from '@/components/atomic/templates/navigation/navigationbrand';
import NavigationBrandlist from '@/components/atomic/templates/navigation/navigationbrandlist';
import NavigationBrandlistcarousel from '@/components/atomic/templates/navigation/navigationbrandlistcarousel';
import NavigationControlContainer from '@/components/atomic/templates/navigation/navigationcontrolcontainer';
import Navmenu from '@/components/atomic/templates/navigation/navmenu';
import Navmenumobile from '@/components/atomic/templates/navigation/navmenumobile';
import NavSearch from '@/components/atomic/templates/navigation/navsearch';
import PreferredRetailer from '@/components/atomic/templates/navigation/preferred-retailer';
import WelcomeBanner from '@/components/atomic/templates/navigation/welcomebanner';
import YourBuilds from '@/components/atomic/templates/navigation/yourbuilds';
import type { MappingConfig } from '@multitenancy-spa/components-manager/esm/services/components-manager/typings';

const componentsToBeMapped: MappingConfig[] = [
	NavSearch,
	Navmenu,
	YourBuilds,
	Navmenumobile,
	NavigationBrandlist,
	NavigationBrandlistcarousel,
	WelcomeBanner,
	ColumnLayoutList,
	ColumnLayoutListCarousel,
	NavigationBrand,
	NameplateCard,
	ColumnLayout,
	GenericColumnLayoutCarousel,
	MenuContainer,
	LanguageSelector,
	MyAccount,
	LinkGroup,
	Image,
	LisOfLinks,
	ImageWithPromoPanel,
	ContentHeader,
	NavigationControlContainer,
	ChatAppContactDetails,
	NavForms,
	PreferredRetailer,
	LiveChat,
];

export default componentsToBeMapped;
